import React, { useEffect, useState } from 'react';
const Newinstagramcampaign = () => {

// const [data ,setData] = useState([]);

// const  fetchUser = async () => {
//     try {
       
//         const res = await fetch('https://jsonplaceholder.typicode.com/photos'); 
//         const data = await res.json();
//        console.log(data);
//        setData(data);
        
//     } catch (error) {
//         console.log(error);
//     }
// }

// useEffect(() => {
//     fetchUser();
//   }, []);


    return (



        <div className="newuser-container">
            <p className="newuser-title fb-campaign-tittle">Add Facebook Campaign</p>
          
          
      
          
{/*           
          
          {
            data && data.length > 0 ? (
              data.map((curval) => (
                <div key={curval.id}>


<table className="dashboard-table">
              <thead>
                <tr>
                <th>id</th>
    <th>title</th>
    <th>url</th>
                </tr>
              </thead>
              <tbody>
              <td>{curval.id}</td>
    <td>{curval.title}</td>
    <td>{curval.url}</td>
              </tbody>
            </table>




                </div>
              ))
            ) : (
              <p>Data is not available</p>
            )
          }
          
           */}
          
          
          
         <div className="newuser-form-box">


                <div className="newuser-form">
                    <div className="newuser-field">
                        <label className="">Campaign Name</label>
                        <input name="campaignName" className="w-full p-2 border" />


                    </div>
                    <div className="newuser-field">
                        <label className="">Objective</label>
                        <select name="objective" className="">
                            <option value="LINK_CLICKS">Link Clicks</option>
                            <option value="CONVERSIONS">Conversions</option>
                            <option value="REACH">Reach</option>
                            <option value="POST_ENGAGEMENT">Post Engagement</option>
                            <option value="BRAND_AWARENESS">Brand Awareness</option>
                        </select>
                    </div>
                    <div className="newuser-field">
                        <label className=" ">Campaign Status</label>
                        <select name="status" lassName="">
                            <option value="ACTIVE">Active</option>
                            <option value="PAUSED">Paused</option>
                        </select>



                    </div>
                    <div className="newuser-field">
                        <label className="">Ad Set Name</label>
                        <input name="adSetName" className="" />


                    </div>
                    <div className="newuser-field">
                        <label className="">Daily Budget (in cents)</label>
                        <input type="number" name="dailyBudget" className="" />


                    </div>


                    <div className="newuser-field">
                        <label className="">Start Time</label>
                        <input type="datetime-local" name="startTime" className="" />

                    </div>
                    <div className="newuser-field">
                        <label className="block mb-1">End Time</label>
                        <input type="datetime-local" name="endTime" className="" />

                    </div>
                    <div className="newuser-field">
                        <label className="">Minimum Age</label>
                        <input type="number" name="ageMin" className="" />


                    </div>
                    <div className="newuser-field">
                        <label className="">Maximum Age</label>
                        <input type="number" name="ageMax" className="" />
                     </div>
                </div>
                <div className="newuser-form">



                 
                    <div className="newuser-field">
                        <label className="">Gender</label>
                        <select name="gender" className="">
                            <option value="all">All</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>

                    </div>

                    <div className="newuser-field">
                        <label className="">Target Location</label>
                        <input name="location" placeholder="e.g. United States" className="" />
                    </div>

                    <div className="newuser-field">
                        <label className="">Interests</label>
                        <input name="interests" placeholder="e.g. fashion,shopping" className="" />
                    </div>


                    <div className="newuser-field">
                        <label className="">Placement</label>
                        <select name="placement" className="">
                            <option value="INSTAGRAM_FEED">Instagram Feed</option>
                            <option value="INSTAGRAM_STORY">Instagram Story</option>
                            <option value="INSTAGRAM_EXPLORE">Instagram Explore</option>
                        </select>

                    </div>

                    <div className="newuser-field">
                        <label className="">Media URL (Image or Video)</label>
                        <input name="mediaUrl" placeholder="https://..." className="" />

                    </div>

                    <div className="newuser-field">
                        <label className="">Caption</label>
                        <textarea name="caption" className="" />

                    </div>

                    <div className="newuser-field">

                        <label className="">Call to Action (CTA)</label>
                        <select name="cta" className="w-full p-2 border">
                            <option value="LEARN_MORE">Learn More</option>
                            <option value="SHOP_NOW">Shop Now</option>
                            <option value="SIGN_UP">Sign Up</option>
                            <option value="WATCH_MORE">Watch More</option>
                        </select>
                    </div>


                    <div className="newuser-field">

                        <label className="">CTA Link</label>
                        <input name="destinationUrl" placeholder="https://..." className="" />

                    </div>



                    <div className='mb-2'>
                        <button type="submit  " className="btn btn-primary newuser-btn">Add Campaign</button>

                    </div>
                </div>
            </div> 
        </div>
    )
};
export default Newinstagramcampaign